/**
 * Text Field - Asset module
 *
 * This module provides methods for implementing text assets as part of a text
 * field. This includes rendering text asset view and edit modes from a template
 * along with UI interactions for selecting an asset
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.textfield.asset');

goog.require('yext.dam.assetselector.events');
goog.require('yext.dam.assetselector.types');
goog.require('yext.storm.location.util');

/**
 * Render the details from asset model into the markup provided
 *
 * @param {!jQuery} $element The text asset edit element
 * @param {TextFieldModel.Asset} asset Asset model
 */
yext.textfield.asset.render = function($element, asset) {
  $element.find('.js-text-asset-name').html(asset.name);
  var assetData = '';
  if (asset.data) {
    assetData = yext.storm.location.util.generateEmbeddedFieldBadges(asset.data);
  }
  $element.find('.js-text-asset-content').html(assetData);
};

/**
 * Returns details of the asset as seen in field display
 * @param {!jQuery} $field The text asset field
 * @return {!Object} asset details
 */
yext.textfield.asset.getStoredAsset = function($field) {
  return {
    name: $field.find('.js-text-asset-name').text(),
    data: $field.find('.js-text-asset-content').text(),
  };
};

/**
 * Binds the asset selector on the text fields
 * @param {!jQuery} $field the field we ar binding
 * @param {function()} selected - the function that selects the asset
 * @param {string} fieldName The name of the field
 * @param {string=} opt_usageType - usage tye of the selector (optional)
 */
yext.textfield.asset.bindSelect = function($field, selected, fieldName, customFieldId, isSuggestedEditMode, opt_usageType, field) {
  let $menu = $field.find('.js-asset-container').find('.js-asset-actions-dropdown');
  let $applyAsset = $menu.find('.js-apply-asset');
  let $clearField = $menu.find('.js-clear-field');

  $field.find('.js-choose-text-asset').click(function(e) {
    if (!$menu.is(':visible')) {
      $('.js-asset-actions-dropdown').hide();
      $menu.show();
      e.stopPropagation();
    }
  });

  $applyAsset.click(function() {
    yext.dam.assetselector.events.show({
      type: yext.dam.assetselector.types.TEXT,
      includeUsedAssets: true,
      isSuggestedEditMode: isSuggestedEditMode,
      usageType: opt_usageType,
    }, fieldName, customFieldId);
    yext.textfield.asset.bindAssetSelector(selected);
  });

  $clearField.click(function() {
    field.clear();
  });

  $(document).click(function() {
    $menu.hide();
  });
};

/**
 * Binds the asset selector
 * @param {function()} selected - the function that 'selects' the asset
 */
yext.textfield.asset.bindAssetSelector = function(selected) {
  $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
    selected(asset);
  });
};

/**
 * Generate markup for a text asset by finding the template and cloning, and
 * binding onRemove and onReplace events to the markup
 *
 * @param {function()} onRemove Callback for on remove
 * @param {function()} onReplace Callback for on replace
 */
yext.textfield.asset.editMarkup = function(onRemove, onReplace, $markup) {
  $markup.find('.js-remove-asset').click(function() {
    onRemove();
  });

  $markup.find('.js-replace-asset').click(function() {
    onReplace();
  });
};

/**
 * Generate view markup by cloning the edit markup and removing the controls
 *
 * @param {!jQuery} $element The asset element
 * @param {TextFieldModel.Asset} asset Asset model
 * @return {!jQuery} The view mode markup
 */
yext.textfield.asset.viewMarkup = function($element, asset) {
  yext.textfield.asset.render($element, asset);
  $element.find('.js-asset-controls').remove();
  return $element;
};
